import { Routes } from '@angular/router';
import { Shell } from './layout/shell/shell';

export const routes: Routes = [
  {
    path: '',
    component: Shell,
    children: [
      {
        path: '',
        loadChildren: () => import('./features/home/home.routes').then((m) => m.homeRoutes),
      },
      {
        path: 'configuration-start',
        loadChildren: () =>
          import('./features/configuration-start/configuration-start.routes').then(
            (m) => m.configurationStartRoutes,
          ),
      },
      {
        path: 'configurator',
        loadChildren: () =>
          import('./features/configurator/configurator.routes').then((m) => m.configuratorRoutes),
      },
      {
        path: 'summary',
        loadChildren: () => import('./features/summary/summary.routes').then((m) => m.summaryRoutes),
      },
      {
        path: 'inquiry',
        loadChildren: () => import('./features/inquiry/inquiry.routes').then((m) => m.inquiryRoutes),
      },
      {
        path: 'spare-part-inquiry',
        loadChildren: () =>
          import('./features/spare-part-inquiry/spare-part-inquiry.routes').then(
            (m) => m.sparePartInquiryRoutes,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
